<template>
  <div class="col-12 col-md-3 right-menu">
    <div class="position-sticky" style="top: 16px">
      <CommunityCard class="px-3 py-2 pb-4" :withHorizontalRules="false">
        <div class="mb-2">
          <div class="filter-title mb-2">
            <img src="../assets/filter.svg" class="mr-2" />
            Filter Scenarios
          </div>
          <div class="filter-clear" @click="clear()">
            <img src="../assets/cross.svg" class="mr-1" />
            Clear
          </div>
        </div>

        <div v-if="includePatientAgeSelector">
          <h5 class="tag-header">Patient Age</h5>

          <div style="padding-bottom: 16px">
            <select
              class="dropdown-btn"
              v-model="selectedPatientAge"
              @change="ageUpdated()"
            >
              <option value="-1">All</option>
              <option value="2">Adult</option>
              <option value="1">Paediatric</option>
              <option value="0">Neonate</option>
            </select>
          </div>
        </div>

        <div v-if="includePatientConditionSelector">
          <h5 class="tag-header">Patient Condition</h5>

          <div style="padding-bottom: 16px">
            <select
              class="dropdown-btn"
              v-model="selectedPatientCondition"
              @change="conditionUpdated()"
            >
              <option value="-1">All</option>
              <option value="2">Stable</option>
              <option value="1">Deteriorating</option>
              <option value="0">Cardiac Arrest</option>
            </select>
          </div>
        </div>

        <div class="d-flex dropdown-container">
          <v-select
            class="tag-dropdown"
            label="title"
            :options="allTags"
            multiple
            v-model="selectedTags"
            @input="tagsUpdated()"
          >
            <template #no-options>
              <em style="opacity: 0.5">no tags found</em>
            </template>
            <template #header>
              <h5 class="tag-header">Tags</h5>
            </template>
          </v-select>
        </div>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import TagObject from "../objects/TagObject";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";

export default {
  name: "ScenarioTagFilter",
  components: {
    CommunityCard,
    Footer,
  },
  props: {
    availableTags: Function,
    startingTags: Function,
    includePatientAgeSelector: { type: Boolean, default: false },
    includePatientConditionSelector: { type: Boolean, default: false },
  },
  data: function () {
    return {
      allTags: [],
      selectedTags: [],
      selectedPatientAge: -1,
      selectedPatientCondition: -1,
    };
  },
  beforeMount() {
    // TODO: move these to vuex
    if (this.startingTags) {
      this.startingTags().then((data) => {
        if (data.tags)
          data.tags.forEach((tag) => this.selectedTags.push(tag.title));
      });
    }

    this.availableTags().then((data) => {
      data.forEach((tag) => {
        if (tag) this.allTags.push(new TagObject(tag));
      });
    });
  },
  methods: {
    tagsUpdated() {
      this.$emit(
        "tag-selection-updated",
        this.selectedTags.map((tag) => tag.id)
      );
    },
    clear() {
      this.selectedTags = [];
      this.selectedPatientAge = -1;
      this.selectedPatientCondition = -1;
      this.$emit("filters-cleared");
    },
    ageUpdated() {
      this.$emit("age-selection-updated", this.selectedPatientAge);
    },
    conditionUpdated() {
      this.$emit("condition-selection-updated", this.selectedPatientCondition);
    },
  },
};
</script>

<style scoped>
.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-title,
.filter-clear {
  color: var(--isim-primary);
  font-size: 1.1rem;
  display: flex;
  align-items: center;
}

.filter-clear {
  padding: 6px 12px;
  background: var(--isim-primary-light);
  cursor: pointer;
  border-radius: 4px;
  display: inline-flex;
}

.dropdown-container {
  width: 100%;
  align-items: flex-end;
}

.dropdown-btn {
  width: 100%;
  display: flex;
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
  white-space: normal;
  padding: 0.375rem 0.375rem;
}

.tag-dropdown.v-select {
  width: 100%;
}

.tag-header {
  color: inherit;
}

.dropdown-menu {
  background-color: var(--light);
}
</style>
